const GeorgiaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111472)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M39.8307 17.3913H22.6088H22.6087V0.169297C21.7548 0.058125 20.8841 0 20 0C19.1159 0 18.2452 0.058125 17.3913 0.169297V17.3912V17.3913H0.169297C0.058125 18.2452 0 19.1159 0 20C0 20.8843 0.058125 21.7548 0.169297 22.6087H17.3912H17.3913V39.8307C18.2452 39.9419 19.1159 40 20 40C20.8841 40 21.7548 39.942 22.6087 39.8307V22.6088V22.6087H39.8307C39.9419 21.7548 40 20.8843 40 20C40 19.1159 39.9419 18.2452 39.8307 17.3913Z"
        fill="#D80027"
      />
      <path
        d="M12.174 9.56578V6.95703H9.56529V9.56578H6.95654V12.1745H9.56529V14.7831H12.174V12.1745H14.7826V9.56578H12.174Z"
        fill="#D80027"
      />
      <path
        d="M30.4346 9.56578V6.95703H27.826V9.56578H25.2173V12.1745H27.826V14.7831H30.4346V12.1745H33.0434V9.56578H30.4346Z"
        fill="#D80027"
      />
      <path
        d="M12.174 27.8255V25.2168H9.56529V27.8255H6.95654V30.4341H9.56529V33.0429H12.174V30.4341H14.7826V27.8255H12.174Z"
        fill="#D80027"
      />
      <path
        d="M30.4346 27.8255V25.2168H27.826V27.8255H25.2173V30.4341H27.826V33.0429H30.4346V30.4341H33.0434V27.8255H30.4346Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111472">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default GeorgiaSvg;
